import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import { LanguageContext } from "../../../../context/languageContext";
import SwissMapImage from "../../../../resources/images/scd-swiss-map.svg";
import CustomTypography from "../../typography";
import { languages } from "../languages";

import "./styles.scss";
import { DrawerContentProps, LanguageOptionProps } from "./types";

const LanguageOption = (props: LanguageOptionProps): React.ReactElement => {
  if (props.isSelected) {
    return (
      <div className="language-item-selected">
        <CustomTypography variant={"body2"} className="language-item-text">
          {props.label}
        </CustomTypography>
      </div>
    );
  }

  return (
    <div
      onKeyPress={(e) => {
        if (e.key === "Enter") {
          e.currentTarget.click();
        }
      }}
      tabIndex={0}
      className="language-item"
      onClick={props.onSelect}
    >
      <CustomTypography variant={"body2"} className="language-item-text">
        {props.label}
      </CustomTypography>
    </div>
  );
};

export const DrawerContent = (
  props: DrawerContentProps,
): React.ReactElement => {
  const { getMessage } = useMessageSource();
  const { language, setLanguage } = useContext(LanguageContext);
  return (
    <div className="scd-language-selection-content">
      <div className="image-map">
        <img alt="Swiss Map" src={SwissMapImage} />
      </div>
      <div className="language-list">
        <CustomTypography variant={"h5"} className="language-list-title">
          {getMessage("Header.language-selection-content-title")}
        </CustomTypography>
        {languages.map(({ textKey, value }) => (
          <LanguageOption
            key={value}
            onSelect={(event) => {
              setLanguage(value);
              props.onSelect(event);
            }}
            label={getMessage(textKey)}
            isSelected={language === value}
          />
        ))}
      </div>
    </div>
  );
};
